import { render, staticRenderFns } from "./GoodsFoot.vue?vue&type=template&id=1001e2e4&"
import script from "./GoodsFoot.vue?vue&type=script&lang=js&"
export * from "./GoodsFoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports